// Import the globalHistory object from @reach/router, which is used by Gatsby
// to manage browser session history.
import { globalHistory } from '@reach/router'

/**
 * This is a Gatsby Browser API hook that runs after a route has changed.
 * @see https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#onRouteUpdate
 */
export const onRouteUpdate = () => {
  // Set up a listener that fires every time the history changes (i.e., on navigation).
  globalHistory.listen(args => {
    // The 'args' object contains 'location' and 'action' (e.g., 'PUSH', 'POP').
    // This line copies the 'action' type onto the 'location' object itself.
    // This makes the navigation type available to other components that might need it,
    // for example, to trigger different animations for forward vs. backward navigation.
    args.location.action = args.action
  })
}
